/** Copyright (c) 2022-present TVM Engineering Authors. */
/* eslint-disable */

import React from "react";
import ReactDOM from "react-dom";
import AppRoutes from "./routes";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { applyMiddleware, createStore } from "redux";
// import { BrowserRouter } from "react-router-dom";

import reduxThunk from "redux-thunk";

import { ToastContainer } from "react-toastify";
import { ThemeProvider } from "@mui/styles";
import { I18nextProvider } from "react-i18next"; // as we build ourself via webpack
import App from "./containers/App";
import types from "./actions/types";
import i18n from "./services/i18n";
import onlineListener from "./utils/onlineListener";
import idleListener from "./utils/idleListener";
import "react-toastify/dist/ReactToastify.css";
import "./assets/fonts/Roboto/Roboto-Light.ttf";
import "./assets/fonts/Roboto/Roboto-Regular.ttf";
import "./index.css";
import "./assets/stylesheets/base.scss";
import Theme from "./theme/theme";
import * as serviceWorker from "./serviceWorker";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import store from "./store/store";
import getTheUserState from "./utils/userState";

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false } },
});

onlineListener(store.dispatch);

const user = getTheUserState();

if (user?.user && user?.token) {
  // Update application state. User has token and is probably authenticated
  store.dispatch({ type: types.AUTH_USER, user: user });
  idleListener(store.dispatch);
}

const Application = (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider theme={Theme.theme}>
      <I18nextProvider i18n={i18n}>
        <Provider store={store}>
          <ToastContainer />
          {/* <BrowserRouter>
          <App history={history} user={user} />
        </BrowserRouter> */}
          <AppRoutes user={user} />
        </Provider>
      </I18nextProvider>
    </ThemeProvider>
    {/* <ReactQueryDevtools /> */}
  </QueryClientProvider>
);

const container = document.getElementById("root");
const root = createRoot(container);

root.render(Application);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
